import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { AlertTriangle, Inbox, SearchX } from "lucide-react";
import * as React from "react";

type TmsStateTone = "empty" | "filtered" | "error";

const TONE_STYLES: Record<TmsStateTone, string> = {
  empty: "border-border/70 bg-muted/20 text-foreground",
  filtered: "border-border/70 bg-muted/20 text-foreground",
  error: "border-red-200 bg-red-50 text-red-900 dark:border-red-900/40 dark:bg-red-950/20 dark:text-red-100",
};

const TONE_ICON: Record<TmsStateTone, React.ComponentType<{ className?: string }>> = {
  empty: Inbox,
  filtered: SearchX,
  error: AlertTriangle,
};

export function TmsStatePanel({
  tone,
  title,
  description,
  actionLabel,
  onAction,
  className,
}: {
  tone: TmsStateTone;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}) {
  const Icon = TONE_ICON[tone];

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-xl border px-6 py-10 text-center",
        TONE_STYLES[tone],
        className,
      )}
    >
      <Icon className="mb-3 size-5" />
      <p className="text-sm font-medium">{title}</p>
      <p className="mt-1 max-w-xl text-sm opacity-80">{description}</p>
      {actionLabel && onAction ? (
        <Button className="mt-4" variant={tone === "error" ? "outline" : "default"} size="sm" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
}
